import React from 'react';
import Layout from "./../components/layout";
import SEO from "./../components/seo";

import Hero from "./../sections/hero";
import Portfolio from "./../sections/portfolio";
import Brands from "./../sections/brands";
import Testimonials from "./../sections/testimonials";
import About from "./../sections/about";
import Services from "./../sections/services";
import Contact from "./../sections/contact";

const Home = () => (
    <Layout>
        <SEO title="Homepage" />
        <Hero /> 
        <Portfolio /> 
        <Brands /> 
        <Testimonials /> 
        <About /> 
        <Services /> 
        <Contact /> 
    </Layout>
)

export default Home;

